import modular from "modujs";
import * as modules from "./modules";
import globals from "./globals";
import { html } from "./utils/environment";
import { gsap } from "gsap";

const app = new modular({
    modules: modules,
});

window.isMobile =
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
    ) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

if (window.isMobile) {
    html.classList.add("is-mobile");
} else {
    html.classList.add("is-desktop");
}
if (window.isMobile) {
    if (window.innerWidth > 1000) {
        window.isTablet = true;
    }
}

window.isWindows = navigator.platform.indexOf("Win") > -1;

if (window.isWindows) {
    html.classList.add("is-windows");
}

window.isIos =
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
if (window.isIos) {
    html.classList.add("is-ios");
}

window.onload = (event) => {
    init();
};

window.firstHit = true;
window.readyDelay = 0.3;
window.readyCallbackDelay = 1;

function init() {
    globals();

    app.init(app);

    html.classList.add("is-loaded");
    html.classList.remove("is-loading");

    gsap.delayedCall(window.readyDelay, () => {
        html.classList.add("is-first-load");
        html.classList.add("is-ready");
        html.classList.add("has-dom-ready");

        gsap.delayedCall(window.readyCallbackDelay, () => {
            html.classList.add("has-dom-ready-callback");

            html.classList.add("has-dom-animated");

            window.firstHit = false;
        });
    });

    // Credits
    if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
        var args = [
            "%c Developed by Quentin Hocdé \u00A9 https://quentinhocde.com \n Made with Index Studio - https://index.studio \n",
            "background: #0D3026; padding:10px 0;color: #ffffff;",
        ];
        window.console.log.apply(console, args);
    } else if (window.console) {
        window.console.log(
            "Developed by Quentin Hocdé - https://quentinhocde.com - made with Index Studio - https://index.studio",
        );
    }
}
